import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Link, Navigate } from "react-router-dom";

import Modal from "react-modal";

import { NewSubject } from './NewSubject';
import useStores from "../../../../../utils/useStores";

import "./Style.css";
import { subjectValidationError } from './subjectValidation';

if (process.env.NODE_ENV !== "test") Modal.setAppElement("#root");

const NewSubjectContainer = ({setModalOpen}: {setModalOpen: any}) => {
    const [routeToNewSubject, setRouteToNewSubject] = React.useState("");
    const [isPublic, setIsPublic] = React.useState(false);
    const [loadingSubjects, setLoadingSubjects] = React.useState(false);
    const [subtitle, setSubtitle] = React.useState("subtitle");
    const [submitSpinner, setSubmitSpinner] = React.useState(false);
    const [errorTitle, setErrorTitle] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [showError, setShowError] = React.useState(false);
    const rootStore = useStores();


    const closeModal = () => {        
        setModalOpen(false);
    }

    const handleSubmit = (title: string, description: string, types: Array<any>, isPublic: boolean) => {
        const validationError = subjectValidationError(title, description);
        if (validationError) {
            setShowError(true);
            setErrorTitle('Subject details required');
            setErrorMessage(validationError);
            setSubmitSpinner(false);
            return;
        }

        setSubmitSpinner(true);
        setShowError(false);

        rootStore.subjectStore.create(
            title.trim(),
            description.trim(),
            types,
            isPublic,
            function(succeeded: boolean, newSubject: any) {
                if (succeeded) {
                    setSubmitSpinner(false);
                    console.log("newSubject");
                    console.log(succeeded);
                    console.log(newSubject);
                    setRouteToNewSubject(`${newSubject.data.subject.user}/${newSubject.data.subject.slug}`);
                } else {
                    const errData = newSubject;
                    setSubmitSpinner(false);
                    setShowError(true);
                    setErrorTitle(errData.title || 'Could not create subject');
                    setErrorMessage(errData.detail || 'Please try again.');
                }
            }
        );
    }

    // togglePublic() {
    //     setIsPublic(!isPublic);
    // }

    if (routeToNewSubject) {
        return (
                <Navigate
                    to={`/subjects/${routeToNewSubject}`}
                />
            );
        } else {

            return (<NewSubject errorTitle={errorTitle} errorMessage={errorMessage} showError={showError} handleSubmit={handleSubmit} submitSpinner={submitSpinner} />);
        }
}

export default observer(NewSubjectContainer);
